import { useReports } from './hooks/useReports';
import { exportToExcel } from './lib/excelExport';
import { useState } from 'react';

export default function SEReports() {
  const { seOrders, seSummary } = useReports();
  const [range, setRange] = useState({ startDate: '', endDate: '' });
  const [activeTab, setActiveTab] = useState('summary');
  
  const ordersQuery = seOrders(range);
  const summaryQuery = seSummary();
  
  if (ordersQuery.isLoading || summaryQuery.isLoading) {
    return <div className="p-6">Loading...</div>;
  }
  
  const ordersData = ordersQuery.data?.data || [];
  const summaryData = summaryQuery.data || {};
  
  const handleExportOrders = () => {
    exportToExcel('SE_Orders_Report', [{
      name: 'Orders',
      headers: ['Date', 'Order Count', 'Total Value', 'Commission'],
      data: ordersData.map((d: any) => [d.date, d.count, d.value, d.commission])
    }]);
  };
  
  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-800">Sales Executive Reports</h1>
        <div className="flex gap-2">
          <button
            onClick={() => setActiveTab('summary')}
            className={`px-4 py-2 rounded-lg ${activeTab === 'summary' ? 'bg-[var(--color-primary)] text-white' : 'bg-gray-100 text-gray-600'}`}
          >
            Summary
          </button>
          <button
            onClick={() => setActiveTab('orders')}
            className={`px-4 py-2 rounded-lg ${activeTab === 'orders' ? 'bg-[var(--color-primary)] text-white' : 'bg-gray-100 text-gray-600'}`}
          >
            Orders Report
          </button>
        </div>
      </div>
      
      {activeTab === 'summary' && (
        <div className="grid md:grid-cols-4 gap-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="text-sm text-gray-600">Total Orders</div>
            <div className="text-2xl font-bold text-[var(--color-primary)]">{summaryData.totalOrders || 0}</div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="text-sm text-gray-600">Total Value</div>
            <div className="text-2xl font-bold text-green-600">₹{(summaryData.totalValue || 0).toLocaleString()}</div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="text-sm text-gray-600">Commission Earned</div>
            <div className="text-2xl font-bold text-blue-600">₹{(summaryData.commission || 0).toLocaleString()}</div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="text-sm text-gray-600">Avg Order Value</div>
            <div className="text-2xl font-bold text-purple-600">₹{(summaryData.avgOrderValue || 0).toLocaleString()}</div>
          </div>
        </div>
      )}
      
      {activeTab === 'orders' && (
        <>
          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <div className="flex gap-4 items-center">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                <input
                  type="date"
                  className="input"
                  value={range.startDate}
                  onChange={e => setRange({ ...range, startDate: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                <input
                  type="date"
                  className="input"
                  value={range.endDate}
                  onChange={e => setRange({ ...range, endDate: e.target.value })}
                />
              </div>
              <div className="flex gap-2 mt-6">
                <button className="btn-primary" onClick={handleExportOrders}>
                  <i className="ri-file-excel-2-line mr-2"></i>
                  Export Excel
                </button>
                <button className="btn-secondary">
                  <i className="ri-file-pdf-line mr-2"></i>
                  Export PDF
                </button>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead className="bg-[var(--color-accent)]/40">
                  <tr>
                    <th className="th">Date</th>
                    <th className="th">Order Count</th>
                    <th className="th">Total Value</th>
                    <th className="th">Commission</th>
                    <th className="th">Performance</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersData.map((row: any, index: number) => (
                    <tr key={index} className="tr">
                      <td className="td">{row.date}</td>
                      <td className="td">{row.count}</td>
                      <td className="td">₹{row.value?.toLocaleString()}</td>
                      <td className="td">₹{row.commission?.toLocaleString()}</td>
                      <td className="td">
                        <span className={`badge ${row.performance >= 80 ? 'approved' : row.performance >= 60 ? 'pending' : 'rejected'}`}>
                          {row.performance}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}